import { useEffect, useState } from "react";
import BibleQuote from "../BibleQuote/BibleQuote";

const DynamicBibleQuote = () => {

  const [quoteData, setQuoteData] = useState({ quote: '', source: '' });

  const fetchQuoteData = async () => {
    fetch('https://laurimikael.fi/bibleQuotesEvl.php')
      .then((res) => res.json())
      .then((json) => {
        setQuoteData({
          quote: json.quote || 'Missä on aarteesi, siellä on myös sydämesi.',
          source: json.source || 'Matt. 6:21',
        });
      })
  }

  useEffect(() => {
    fetchQuoteData();
  }, []);

  return (
    <BibleQuote
      className={!quoteData.quote ? 'opacity-0' : 'opacity-100'}
      quote={quoteData.quote}
      source={quoteData.source}
    />
  )
};

export default DynamicBibleQuote;